import * as LightTheme from './light'

export default LightTheme
